import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MeasuresViewModel } from '../../view-models/chart-viewmodel';
import { GridOptions } from 'ag-grid-community';

export interface ICustomMeasureButton {
    tag: any;
    text: string;
    valueToSet: number;
}

@Component({
    selector: 'caliper-measures',
    templateUrl: './caliper-measures.component.html',
    styleUrls: ['./caliper-measures.component.scss'],
})
export class CaliperMeasuresComponent {
    // Data Members

    @Output()
    measuresRemove = new EventEmitter<MeasuresViewModel>();
    @Output()
    measuresRemoveAll = new EventEmitter<any>();
    @Output()
    measuresSet = new EventEmitter<ICustomMeasureButton>();
    @Input()
    measuresList!: Array<MeasuresViewModel>;
    @Input()
    customMeasureButtons!: ICustomMeasureButton[];
    @Input()
    readOnly: boolean = false;

    gridOptions: GridOptions;
    get selectedMeasures(): MeasuresViewModel | null {
        if (!this.measuresList) return null;

        let measures = this.measuresList.filter((item) => item.selected);
        if (!measures || measures.length !== 1) return null;

        return measures[0];
    }

    // Constructor

    constructor() {
        this.gridOptions = <GridOptions>{
            enableCellChangeFlash: true,
            refreshCells: true,
            suppressCellFocus: true,
        };
    }

    // public functions

    onRemove(measures: MeasuresViewModel) {
        this.measuresRemove.emit(measures);
    }

    onMouseOver(measures: MeasuresViewModel) {
        measures.caliper.highlight = true;
    }

    onMouseOut(measures: MeasuresViewModel) {
        measures.caliper.highlight = false;
    }

    onRemoveAll() {
        this.measuresRemoveAll.emit();
    }

    onSelect(measures: MeasuresViewModel) {
        this.measuresList.forEach((measures) => (measures.selected = false));
        measures.selected = true;
    }

    onClick(customMeasureButton: ICustomMeasureButton) {
        this.measuresSet.emit(customMeasureButton);
    }
}
